import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import IconBadge from "@react/shared/ui/IconBadge"
import { useDropdownMenu, MenuPanel } from "@react/shared/ui/DropdownMenu"
import { COST_CATEGORIES, costCategoryVisual } from "@react/quotes/qline_service_blueprints/kinds"

const MENU_WIDTH = 180

const KindPicker = ({ value, onChange, enabledCategories }) => {
  const { open, close, toggle, pos, btnRef, menuRef } = useDropdownMenu({ width: MENU_WIDTH })

  const pick = next => e => {
    e.stopPropagation()
    close()
    onChange?.(next)
  }

  const allowedKeys = (Array.isArray(enabledCategories) && enabledCategories.length > 0)
    ? enabledCategories
    : COST_CATEGORIES.map(category => category.value)
  const visible = COST_CATEGORIES.filter(category => allowedKeys.includes(category.value) || category.value === value)

  const visual = costCategoryVisual(value)

  return (
    <>
      <button
        ref      = {btnRef}
        type     = "button"
        title    = {I18n.t("quotes.builder.kind_picker.category")}
        onClick  = {toggle}
        className= "shrink-0 outline-none focus:outline-none"
      >
        <IconBadge tone={visual.tone} size="sm">
          <FontAwesomeIcon icon={visual.icon} />
        </IconBadge>
      </button>

      {open && (
        <MenuPanel menuRef={menuRef} pos={pos} width={MENU_WIDTH}>
          {visible.map(category => {
            const categoryVisual = costCategoryVisual(category.value)
            const isActive       = category.value === value
            return (
              <button
                key       = {category.value}
                type      = "button"
                onClick   = {pick(category.value)}
                className = {`w-full flex items-center gap-2 px-2 py-1.5 rounded-md bg-transparent border-0 cursor-pointer text-[13px] font-medium text-left ${isActive ? "bg-slate-100 text-slate-900" : "text-slate-700 hover:bg-slate-50"}`}
              >
                <IconBadge tone={categoryVisual.tone} size="sm">
                  <FontAwesomeIcon icon={categoryVisual.icon} />
                </IconBadge>
                <span>{category.label}</span>
              </button>
            )
          })}
        </MenuPanel>
      )}
    </>
  )
}

export default KindPicker
